import React from "react";
import { NotificationBarType } from ".";
import IconWrapper from "../Icons/IconWrapper";
export const NotificationBarIcon = ({ type }) => {
    switch (type) {
        case NotificationBarType.Info:
            return React.createElement(IconWrapper, { name: "Info", title: "Alert icon" });
        case NotificationBarType.Alert:
            return React.createElement(IconWrapper, { name: "AlertCircle", title: "Alert icon" });
        case NotificationBarType.Warning:
            return React.createElement(IconWrapper, { name: "AlertTriangle", title: "Warning icon" });
        case NotificationBarType.Success:
            return React.createElement(IconWrapper, { name: "CheckCircle", title: "Success icon" });
        default:
            return null;
    }
};
export default NotificationBarIcon;
//# sourceMappingURL=NotificationBarIcon.js.map